import React from 'react'
import PropTypes from 'prop-types'

import styles from './CallToAction.module.scss'

const CallToAction = ({ showContactForm }) => (
    <button type="button" className={styles.getInTouch} onClick={showContactForm}><strong>get in touch with us &gt;</strong></button>
)

CallToAction.propTypes = {
    showContactForm: PropTypes.func.isRequired,
}

export default CallToAction
